// extracted by mini-css-extract-plugin
var _1 = "webpack-system-base-Dialog-Banner-module__banner";
var _2 = "webpack-system-base-Dialog-Banner-module__container";
var _3 = "webpack-system-base-Dialog-Banner-module__error webpack-system-base-Dialog-Banner-module__banner";
var _4 = "webpack-system-base-Dialog-Banner-module__icon";
var _5 = "webpack-system-base-Dialog-Banner-module__info webpack-system-base-Dialog-Banner-module__banner";
var _6 = "webpack-system-base-Dialog-Banner-module__warning webpack-system-base-Dialog-Banner-module__banner";
export { _1 as "banner", _2 as "container", _3 as "error", _4 as "icon", _5 as "info", _6 as "warning" }
